var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollarOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.41712 3.75C8.90046 3.75 9.45046 4.45833 9.50046 5.5H11.3421C11.2838 4.06667 10.4088 2.75 8.66712 2.325V0.5H6.16712V2.3C5.72546 2.4 5.30879 2.55 4.93379 2.75L6.15879 3.975C6.50046 3.83333 6.91712 3.75 7.41712 3.75ZM1.44212 1.38333L0.383789 2.44167L3.25046 5.30833C3.25046 7.04167 4.55046 7.98333 6.50879 8.56667L9.43379 11.4917C9.15046 11.8917 8.55879 12.25 7.41712 12.25C5.70046 12.25 5.02546 11.4833 4.93379 10.5H3.10046C3.20046 12.325 4.56712 13.35 6.16712 13.6917V15.5H8.66712V13.7083C9.46712 13.5583 10.1838 13.25 10.7088 12.775L12.5588 14.625L13.6171 13.5667L1.44212 1.38333Z",
    fill: "#4C5C68"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarOff);
export default __webpack_public_path__ + "static/media/dollar_off.fce3a032606020cd38d24b705cba48f2.svg";
export { ForwardRef as ReactComponent };